import Vue from 'vue'
import VueI18n from 'vue-i18n'
import hk from './hk-HK.json'
import sg from './sg-SG.json'
import th from './th-TH.json'

Vue.use(VueI18n)

export default new VueI18n({
    locale: 'hk',
    messages: {
        hk: { lang: hk },
        sg: { lang: sg },
        th: { lang: th }
    }
})